export class LimiteGlobalStatus {
	'Tipo': string;
	'Retorno': LimiteGlobalStatusRetorno;
	'Sucesso': boolean;
	'Existe': boolean;
	'Mensagem': string;
}

export class LimiteGlobalStatusRetorno {
	'NumeroConta': string;
	'Agencia': string;
	'LimiteGlobal': boolean;
}

export class LimiteGlobalRetornoProduto {
	'Codigo': string;
	'Nome': string;
	'DataEmissao': string;
	'ValorTotal': number;
	'ValorUtilizado': number;
	'ValorDisponivel': number;
	'PermiteAlterarValor': boolean;
}

export class LimiteGlobalRetornoContrato {
	'Contrato': LimiteGlobal;
}

export class LimiteGlobalRetornoCliente {
	'Codigo': string;
	'Nome': string;
	'Documento': string;
}

export class LimiteGlobalRetornoGarantiaVeiculo {
	'Modelo': string;
	'Marca': string;
	'MarcaModelo': string;
	'AnoFabricacao': number;
	'AnoModelo': number;
	'Cor': string;
	'Placa': string;
	'Fipe': string;
	'Versao': string;
	'Combustivel': string;
}

export class LimiteGlobal {
	'Codigo': string;
	'DataEmissao': string;
	'Produtos': LimiteGlobalRetornoProduto[];
	'Cliente': LimiteGlobalRetornoCliente;
	'GarantiaVeiculo': LimiteGlobalRetornoGarantiaVeiculo;
	'ValorTotal': number;
	'ValorUtilizado': number;
	'ValorDisponivel': number;
}

export class LimiteGlobalRetorno {
	'Tipo': string;
	'Retorno': LimiteGlobalRetornoContrato;
	'Sucesso': boolean;
	'Existe': boolean;
	'Mensagem': string;
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/limite-global/models/limite-global.ts